import type { ThemeColors } from '../../../src/theme/themes';

export type WcColors = {
  bg: string;
  panel: string;
  panelHi: string;
  line: string;
  lineHi: string;
  ink: string;
  inkDim: string;
  inkMute: string;
  purple: string;
  purpleHi: string;
  purpleDeep: string;
  yellow: string;
  green: string;
  red: string;
  blue: string;
  home: string;
  draw: string;
  away: string;
  /** Always white — for text/icons sitting on a dark primary/purple background. */
  textOnPrimary: string;
};

export function getWcColors(theme: ThemeColors): WcColors {
  return {
    bg: theme.background.primary,
    panel: theme.background.card,
    panelHi: theme.gray[200],
    line: theme.gray[300],
    lineHi: theme.gray[400],
    ink: theme.black,
    inkDim: theme.gray[700],
    inkMute: theme.gray[600],
    purple: theme.primary,
    purpleHi: theme.primaryLight,
    purpleDeep: theme.primaryDark,
    yellow: theme.accentDark,
    green: theme.secondary,
    red: theme.error,
    blue: theme.info,
    home: '#FF8A65',
    draw: '#9C8FB8',
    away: theme.info,
    textOnPrimary: '#FFFFFF',
  };
}

export function getMatchPickStatsHeaderGradientColors(C: WcColors): readonly [string, string, string] {
  return [C.purple + '33', C.purple + '12', 'transparent'];
}

export function getAvatarInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Hash-based color for a given name string (deterministic). */
export function getAvatarColorByName(name: string, palette: readonly string[]): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return palette[Math.abs(hash) % palette.length];
}

/** Index-based color for ordered lists. */
export function getAvatarColorByIndex(index: number, palette: readonly string[]): string {
  return palette[index % palette.length];
}
